import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';
import { Icon } from 'components/common/icons';
import { ProgressLabel } from '.';

interface Props {
  numberOfAnswers: number;
  numberOfTasks: number;
  numberOfUnreviewedTasks?: number;
  showLabelTitle?: boolean;
}

const AnswersProgress = ({
  numberOfAnswers,
  numberOfTasks,
  numberOfUnreviewedTasks,
  showLabelTitle
}: Props) => {
  const { messages, theme } = useReduxState();

  if (!numberOfTasks) {
    return (
      <div
        style={{
          color: theme.textColorLighter,
          fontSize: '1.3rem',
          whiteSpace: 'nowrap'
        }}
      >
        {messages.tasksNoTasks}
      </div>
    );
  }

  const tooltip = `${numberOfUnreviewedTasks} ${messages.coursesUnreviewedAnswers}`;

  return (
    <div className="progress">
      <ProgressBar
        ariaLabel={messages.tasksAnswers}
        color="rgba(0, 0, 0, 0.4)"
        label={
          <ProgressLabel
            title={showLabelTitle ? messages.tasksAnswers : undefined}
            value={
              <div style={{ display: 'flex', gap: 5 }}>
                {`${numberOfAnswers}/${numberOfTasks}`}
                {numberOfUnreviewedTasks ? (
                  <div
                    aria-label={tooltip}
                    data-tooltip={tooltip}
                    style={{
                      display: 'grid',
                      alignItems: 'center',
                      justifyItems: 'center'
                    }}
                  >
                    <Icon
                      color={theme.dangerColor}
                      icon="circle"
                      fixedWidth={true}
                      style={{ gridColumn: 1, gridRow: 1 }}
                    />
                    <div
                      style={{
                        color: theme.mainTextColor,
                        fontSize: '1rem',
                        gridColumn: 1,
                        gridRow: 1
                      }}
                    >
                      {numberOfUnreviewedTasks}
                    </div>
                  </div>
                ) : null}
              </div>
            }
          />
        }
        progress={numberOfAnswers / numberOfTasks}
        style={{ width: showLabelTitle ? '100%' : 64 }}
      />
    </div>
  );
};

export default AnswersProgress;
